AuthRoute = require 'mixins/authenticated-route'

App.PromosCreateRoute = Em.Route.extend AuthRoute,
  controllerName: 'promos.edit'
  templateName:   'promos.edit'

  session: Em.inject.service()

  model: ->
    organization = @get('session.currentOrganization')

    unless organization
      return Em.RSVP.reject 'No current organization context found'

    genTime = (hh, mm) ->
      moment(y: 2000, M: 0, d: 1, h: hh, m: mm, s: 0, ms: 0).toDate()

    timetables = [0...7].map (day) ->
        Em.Object.create(
          id: null
          day: day,
          open_at:  genTime(0, 0),
          close_at: genTime(23, 59),
          is_working: true)

    @store.createRecord 'promo',
      # todo i18n
      name: 'Новая акция'
      organization: organization
      timetables: timetables
